export type IAutoUploadImages = (input: HTMLInputElement | JQuery<HTMLInputElement>) => void;

export function _autoUploadImages(input: HTMLInputElement | JQuery<HTMLInputElement>): void {
  const $input = $(input) as IjQueryElm;
  const $form = $input.closest('form');
  const options = window.DexeroCoreApp.getUserOptions();
  const { langObj = {} } = options;
  const json: {
    formId: string;
    waitMsg: string;
    uploadErrorTitle: string;
    uploadErrorMessage: string;
  } = JSON.parse(decodeURIComponent($input.data('json')));

  // Messages
  const { formId, waitMsg, uploadErrorTitle, uploadErrorMessage } = json;

  // URL retrieval components
  const postUrl = `/public/AjaxFormUploadFile.action?formId=${formId}`;

  // Block form
  window.DexeroCoreApp.blockUI(waitMsg, $form);

  // Form Object
  const formData = new FormData();
  formData.append('theFile', ($input[0] as any).files[0]);
  // Upload image to temporary location
  $.ajax({
    cache: false,
    contentType: false,
    data: formData,
    processData: false,
    timeout: 90000,
    type: 'POST',
    url: postUrl,
    error(jqXHR, textStatus) {
      if (textStatus === 'timeout') {
        const errorTitle = langObj.errorText;
        const errorMessage = langObj.unableToLoadPageText;
        window.DexeroCoreApp.userToastMsg('error', errorTitle, errorMessage);
      }
    },
  }).done((responseData) => {
    const parsedResponseData = JSON.parse(responseData);
    if (parsedResponseData.success === true && parsedResponseData.isImage) {
      // Update view image / crop image / delete image buttons
      window.DexeroCoreApp._setImageUploadButtonElms(input, parsedResponseData);
      // Unblock form
      window.DexeroCoreApp.blockUI(waitMsg, $form, true);
    } else {
      window.DexeroCoreApp.userToastMsg(
        'error',
        uploadErrorTitle,
        `${uploadErrorMessage} ${parsedResponseData.error}`
      );
      // Unblock form
      window.DexeroCoreApp.blockUI(waitMsg, $form, true);
    }
  });
}
